import React from 'react';
import PropTypes from 'prop-types';
import {gql} from 'apollo-boost';
import {Query} from 'react-apollo';
import {trackEventByUrl} from "../helpers/events";
import PageNotFound from "../pages/404/404";

interface Data {
    mediaById: {
        fieldFile: Array<{
            entity: Array<{
                entityLabel: String;
                url: String;
            }>;
        }>;
    }
}

class MediaQuery extends Query<Data, {id: string}> {}

const GET_PAGE = gql`
query mediaById($id: String!) {
  mediaById(id: $id) {
          ... on MediaImage {
              fieldMediaImage {
                  url
              }
          }
          ... on MediaVideo {
              fieldMediaVideoFile {
                  entity {
                      url
                  }
              }
          }
          ... on MediaAudio {
              fieldMediaAudioFile {
                  entity {
                      url
                  }
              }
          }
    }
  }
`;

const Media = ({id, history}) => {
    if (id === 'loading') {
        return null;
    }
    return (<MediaQuery asyncMode query={GET_PAGE} variables={{ id }}>
        {({ loading, error, data }) => {
            if (loading) return (<div className="pageLoader"/>);

            if (error || !data || !data.mediaById || !data.mediaById.fieldFile || !data.mediaById.fieldFile.entity || !data.mediaById.fieldFile.entity.url) {
                return (<PageNotFound/>);
            }

            const file = data.mediaById.fieldFile.entity;

            trackEventByUrl(file.url, file.entityLabel);

            // Open Browsers built-in PDF Viewer (Chrome, Safari), or download (Firefox)
            window.location.href = file.url;

            // Render downloading message as fallback
            return (<div style={{padding: '50px 0 100px'}}>
                <div className="container">
                    <h1 style={{fontSize: '24px'}}>{file.entityLabel}</h1>
                    <p>Your file should start to download automatically. If it does not you can manually download it by clicking <a href={file.url}>here</a>.</p>
                    {history.length > 1 && (
                        <p>
                            <button className="button button--primary"
                                   style={{cursor: 'pointer'}}
                                   onClick={() => history.goBack()}>
                                Go back
                            </button>
                        </p>
                    )}
                </div>
            </div>);
        }}
    </MediaQuery>);

};

Media.propTypes = {
    id: PropTypes.string.isRequired,
    // eslint-disable-next-line react/forbid-prop-types
    history: PropTypes.object.isRequired
};

export default Media;



// WEBPACK FOOTER //
// ./frontend/components/Media.jsx